import React from 'react';

import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => createStyles({
  toolbarWrap: {
    display: 'flex',
    background: '#FFF',
    // Верстка для экранов выше 600px
    gap: 40,
    flex: 1,
    padding: '0 24px',
    height: 64,
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'nowrap', // Все в одну строку
    [theme.breakpoints.down(960)]: {
      gap: 20,
    },
    // Верстка для экранов ниже 600px
    [theme.breakpoints.down(600)]: {
      flexWrap: 'nowrap', // Все в одну строку
      gap: 4, // Уменьшаем gap для компактности
      padding: '0 12px',
      height: 'auto',
      minHeight: 40, // Еще меньше высота
      alignItems: 'center',
      paddingTop: theme.spacing(0.5), // Уменьшаем вертикальные отступы
      paddingBottom: theme.spacing(0.5),
      justifyContent: "space-between",
    },
    [theme.breakpoints.down(480)]: {
      padding: `0 12px`,
    },
  },
  toolbarWrapLeft: {
    display: 'flex',
    gap: 40,
    flex: 1,
    padding: '0 24px',
    height: 64,
    background: '#FFF',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
}));

interface IProps {
  children: React.ReactNode;
  isBackButton?: boolean;
}

const PageHeaderWrap: React.FC<IProps> = ({ children, isBackButton }) => {
  const classes = useStyles();
  return (
    <div className={isBackButton ? classes.toolbarWrapLeft : classes.toolbarWrap}>
      {children}
    </div>
  );
};

export default PageHeaderWrap;
